export default "__VITE_ASSET__Dil6fzRU__"